import { render, staticRenderFns } from "./create-logistics.vue?vue&type=template&id=1334ceb4"
import script from "./create-logistics.vue?vue&type=script&lang=ts"
export * from "./create-logistics.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports